import React from 'react';
import { AppStoreButton, GooglePlayButton } from '../common/StoreButtons';

const DownloadSection: React.FC = () => {
    return (
        <section
            id="get"
            className="relative z-[1] scroll-mt-24 overflow-hidden border-t border-dark-gunmetal px-5 py-[clamp(80px,11vw,150px)]"
        >
            {/* Breathing glow centred on 50%/44%. The wrapper owns the centring
                transform so the scale animation cannot clobber it. */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute left-1/2 top-[44%] aspect-square w-[min(760px,130vw)] -translate-x-1/2 -translate-y-1/2"
            >
                <div className="h-full w-full animate-breathe-scale rounded-full bg-cta-glow blur-[20px]" />
            </div>

            <div className="relative mx-auto max-w-[800px] text-center">
                <h2 className="text-[clamp(32px,5.2vw,66px)] font-extrabold leading-none tracking-[-0.04em] text-white [text-wrap:balance]">
                    Understand the numbers behind your food
                </h2>
                <p className="mx-auto mt-[22px] max-w-[40ch] text-[17px] leading-[1.6] text-dark-textSecondary">
                    Download Fork and get your first nutrition score from a single photo.
                </p>

                <div className="mt-9 flex flex-wrap justify-center gap-3">
                    <AppStoreButton tall />
                    <GooglePlayButton tall />
                </div>
            </div>
        </section>
    );
};

export default DownloadSection;
